import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a3a5701"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-body" }, "Select the organizational areas where you want to see deviations from", -1))
const _hoisted_2 = { class: "input-container" }
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = { class: "input-container" }
const _hoisted_5 = { class: "input-container" }
const _hoisted_6 = { class: "input-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { text: "" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Select Areas")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.clearAreas,
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_label, null, {
              default: _withCtx(() => [
                _createTextVNode("SVP Area")
              ]),
              _: 1
            }),
            _createVNode(_component_ion_select, {
              modelValue: _ctx.areaFilterModel.svp.selected,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.areaFilterModel.svp.selected) = $event)),
              placeholder: _ctx.areaFilterModel.svp.items.length ? 'Choose one or multiple options' : 'No options available',
              disabled: !_ctx.areaFilterModel.svp.items.length,
              multiple: "true",
              interface: "alert",
              "interface-options": { cssClass: 'filter-ion-alert-css' },
              onIonChange: _ctx.autoSaveFilter
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaFilterModel.svp.items, (item) => {
                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                    value: item.value,
                    key: item.key
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled", "onIonChange"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ion_label, null, {
              default: _withCtx(() => [
                _createTextVNode("CVP Area")
              ]),
              _: 1
            }),
            _createVNode(_component_ion_select, {
              modelValue: _ctx.areaFilterModel.cvp.selected,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.areaFilterModel.cvp.selected) = $event)),
              placeholder: _ctx.areaFilterModel.cvp.items.length ? 'Choose one or multiple options' : 'No options available',
              disabled: !_ctx.areaFilterModel.cvp.items.length,
              multiple: "true",
              interface: "alert",
              "interface-options": { cssClass: 'filter-ion-alert-css' },
              onIonChange: _ctx.autoSaveFilter
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaFilterModel.cvp.items, (item) => {
                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                    value: item.value,
                    key: item.key
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled", "onIonChange"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ion_label, null, {
              default: _withCtx(() => [
                _createTextVNode("VP Area")
              ]),
              _: 1
            }),
            _createVNode(_component_ion_select, {
              modelValue: _ctx.areaFilterModel.vp.selected,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.areaFilterModel.vp.selected) = $event)),
              placeholder: _ctx.areaFilterModel.vp.items.length ? 'Choose one or multiple options' : 'No options available',
              disabled: !_ctx.areaFilterModel.vp.items.length,
              multiple: "true",
              interface: "alert",
              "interface-options": { cssClass: 'filter-ion-alert-css' },
              onIonChange: _ctx.autoSaveFilter
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaFilterModel.vp.items, (item) => {
                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                    value: item.value,
                    key: item.key
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled", "onIonChange"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ion_label, null, {
              default: _withCtx(() => [
                _createTextVNode("Department")
              ]),
              _: 1
            }),
            _createVNode(_component_ion_select, {
              modelValue: _ctx.areaFilterModel.department.selected,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.areaFilterModel.department.selected) = $event)),
              placeholder: _ctx.areaFilterModel.department.items.length ? 'Choose one or multiple options' : 'No options available',
              disabled: !_ctx.areaFilterModel.department.items.length,
              multiple: "true",
              interface: "alert",
              "interface-options": { cssClass: 'filter-ion-alert-css' },
              onIonChange: _ctx.autoSaveFilter
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaFilterModel.department.items, (item) => {
                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                    value: item.value,
                    key: item.key
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled", "onIonChange"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ion_label, null, {
              default: _withCtx(() => [
                _createTextVNode("Team")
              ]),
              _: 1
            }),
            _createVNode(_component_ion_select, {
              modelValue: _ctx.areaFilterModel.team.selected,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.areaFilterModel.team.selected) = $event)),
              placeholder: _ctx.areaFilterModel.team.items.length ? 'Choose one or multiple options' : 'No options available',
              disabled: !_ctx.areaFilterModel.team.items.length,
              multiple: "true",
              interface: "alert",
              "interface-options": { cssClass: 'filter-ion-alert-css' },
              onIonChange: _ctx.autoSaveFilter
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaFilterModel.team.items, (item) => {
                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                    value: item.value,
                    key: item.key
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled", "onIonChange"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}